import './src/scss/_style.scss';

const CSS_CLASSES = {
	ELEMENT: 'mainslider',
	SLIDER: 'mainslider__slider',
	SLIDES: 'mainslider__slides',
	ITEM: 'mainslider__item',
	LINK: 'mainslider__link',
	BACKGROUND: 'mainslider__background',
	NAV_CONTAINER: 'swiper-pagination',
	NEXT_BUTTON: 'mainslider__next'
};

class MainSlider
{
	static get DEFAULT_OPTIONS()
	{
		return {
			autoplay: true,
			autoplayDelay: 7500,
			autoplaySpeed: 300
		};
	}

	constructor(element, options = {})
	{
		this.element = element;
		this.slides = this.element.querySelector(`.${CSS_CLASSES.SLIDES}`);
		this.navContainer = this.element.querySelector(`.${CSS_CLASSES.NAV_CONTAINER}`);

		this.options = {...MainSlider.DEFAULT_OPTIONS, ...options };

		if (window.Swiper)
		{
			this.initSlider();
			this.initKeyboard();
			this.fixResponsiveResize();
		}
	}

	initSlider()
	{
		const sliderOptions = {
			el: this.element,
			autoHeight: true,
			loop: true,
			spaceBetween: 0,
			slidesPerView: 1,
			effect: 'slide',
			// simulateTouch: false,
			speed: this.options.autoplaySpeed,
			roundLengths: true,
			passiveListeners: true,
			navigation: {
				nextEl: `.${CSS_CLASSES.NEXT_BUTTON}`,
			},
			pagination: {
				el: this.navContainer,
				type: 'bullets',
				bulletElement: 'button',
				clickable: true,
				renderBullet(index, className)
				{
					const title = this.el.querySelector(`[data-index="${index}"]`)?.dataset.title;
					return `<button class="${className}" aria-label="${title}"></button>`;
				}
			},
			on: {
				init: this.updateColor,
				slideChange: this.updateColor
			}
		};
		if (this.options.autoplay)
		{
			sliderOptions.autoplay = {
				delay: this.options.autoplayDelay,
			};
		}

		this.slider = new Swiper(sliderOptions);
	}

	updateColor(swiper)
	{
		const slide = swiper.slides[swiper.activeIndex];
		swiper.$el.attr('data-color', slide.dataset.color);
	}

	fixResponsiveResize()
	{
		window.addEventListener('resize', () => {
			const slide = this.slider.slides[this.slider.activeIndex];
			const picture = slide.querySelector(`picture > .${CSS_CLASSES.BACKGROUND}`);
			if (picture && !picture.complete)
				picture.onload = () => this.slider.updateAutoHeight();
		});
	}

	initKeyboard()
	{
		if (this.navContainer)
		{
			this.navContainer.addEventListener('keydown', ({ key }) => {
				if (key !== 'Enter')
					return;

				const slide = this.slider.slides[this.slider.activeIndex];
				slide.querySelector('a[href]').click();
			});
		}
	}
}


export { MainSlider };